const READY_FOR_INIT = 'READY_FOR_INIT';
const APP_INIT = 'APP_INIT';
const NAVIGATE = 'NAVIGATE';
export { APP_INIT, NAVIGATE, READY_FOR_INIT };

//# sourceMappingURL=messages.js.map